const positiveId = (value) => /^[1-9][0-9]*$/.test(String(value ?? ''));

export const receivingAddressSelection = ({ addressId, companyAddressId } = {}) => {
  if (positiveId(companyAddressId)) return `company-${companyAddressId}`;
  if (positiveId(addressId)) return `address-${addressId}`;
  return '';
};

export const groupReceivingAddressOptions = ({ companyAddresses = [], standardAddresses = [] } = {}) => {
  const companies = (Array.isArray(companyAddresses) ? companyAddresses : [])
    .filter((item) => positiveId(item.id))
    .map((item) => ({
      id: `company-${item.id}`, group: 'Company Contact Info',
      name: item.name || `Company address #${item.id}`,
      disabled: item.complete !== true,
    }));
  const saved = (Array.isArray(standardAddresses) ? standardAddresses : [])
    .filter((item) => positiveId(item.id))
    .map((item) => ({
      id: `address-${item.id}`, group: 'Saved addresses',
      name: item.name || `Saved address #${item.id}`,
      disabled: item.complete !== true,
    }));
  return { companies, saved, all: [...companies, ...saved] };
};

export const canManageDecoratorReceivingAddress = (user = {}) => {
  const roles = [
    ...(Array.isArray(user.roles) ? user.roles : typeof user.roles === 'string' ? user.roles.split(',') : []),
    user.role,
  ].map((value) => String(typeof value === 'object' ? value?.value ?? value?.role ?? value?.name ?? '' : value || '')
    .trim().toLowerCase().replace(/[_\s]+/g, '-'));
  return roles.some((value) =>
    ['administrator', 'admin', 'super-administrator', 'superadmin'].includes(value)
  );
};
